"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Link;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _button = _interopRequireDefault(require("@ux/button"));
var _core = require("@linaria/core");
var _motionFunctions = require("../motion-functions");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _base = require("@site/pattern-library-utils/base.functions");
var _icon = require("@site/pattern-library-utils/icon");
var _tracking = require("@site/pattern-library-utils/tracking");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _scriptActions = require("./script-actions");
/* eslint-disable complexity */
/* eslint-disable max-params */
/* eslint-disable max-len */

const linkButtonStyles = "core-lgk07f2";
const arrowStyles = "core-ae8rm1";
const underlineStyles = "core-u10z8z9h";

/**
  * Render an <a> link in a variety of formats
  * @module Link
  *
  * @param {Object} props React props for for element
  * @param {String} props.id  Unique id
  * @param {String} props.text link text
  * @param {String} props.href URI to link to
  * @param {bool} props.external if url goes external
  * @param {Array} props.rels Array of rel strings
  * @param {string} props.windowOptions if url goes external (old to be removed)
  * @param {String} props.disabled if button is disabled
  * @param {String} props.design variant design
  * @param {String} props.icon icon to show to the left of the text, can be omitted
  * @param {Boolean} props.inverted Inver button
  * @param {String} props.partial Theme partial
  * @param {String} props.ariaLabel Aria Label
  * @param {String} props.dataCy Cypress name
  * @param {String} props._name tracking name for button
  * @param {String} props.shrinkOn Mobile or Tablet Default Button Shrinks
  * @param {Function} props.onClick Forwarded Func (used by other Pattern Library components, not expected to be passed in from the CMS)
  * @param {String} props.scriptAction The name of the script to execute.
  * @param {Boolean} props.isPromo Use promo (default) or eid
  * @param {object} props.trackingCustomProperties Custom properties object
  * @param {string} props.partial Partial
  * @returns {React.ReactElement} Clickable Link component
  * @public
  */
function Link({
  id,
  design = 'inline',
  text,
  href,
  external,
  rels,
  windowOptions,
  icon,
  inverted = false,
  partial,
  disabled = false,
  anchor,
  anchorOffset,
  ariaLabel,
  dataCy,
  _name,
  shrinkOn,
  onClick,
  scriptAction,
  isPromo = true,
  trackingCustomProperties = {},
  ...rest
}) {
  const tracking = (0, _tracking.create)(_name, true, isPromo, trackingCustomProperties);
  const iconComponent = icon && /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: icon
  });
  const iconAttributes = iconComponent ? {
    icon: iconComponent
  } : {};
  const merchArrowAttr = design === 'arrow' ? {
    as: 'cta'
  } : {};
  let anchorAttr, onClickAttr;
  if (anchor) {
    anchorAttr = {
      'data-target': anchor
    };
    onClickAttr = {
      onClick: evt => {
        evt.preventDefault();
        (0, _base.scrollToAnchor)(evt.currentTarget, anchorOffset);
      }
    };
  } else if (onClick || scriptAction) {
    onClickAttr = {
      onClick: evt => {
        evt.preventDefault();
        if (scriptAction) {
          (0, _scriptActions.executeScriptAction)(scriptAction);
        }
        if (onClick) {
          onClick(evt);
        }
      }
    };
  }
  const targetAttr = external || windowOptions === '_blank' ? {
    target: '_blank',
    rel: (0, _base.arrToString)(rels)
  } : {};
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    id: id,
    text: text,
    href: href || '#',
    design: "inline",
    "data-size": "default",
    disabled: disabled,
    "data-cy": dataCy || 'link',
    "data-design": design,
    "data-partial": partial || (inverted ? 'dark1' : ''),
    "aria-label": ariaLabel,
    "data-shrink": shrinkOn,
    className: `${linkButtonStyles} ${underlineStyles} ${design === 'arrow' ? arrowStyles : ''}`
  }, tracking, anchorAttr, onClickAttr, merchArrowAttr, iconAttributes, targetAttr, rest)));
}
Link.propTypes = {
  id: _propTypes.default.string,
  text: _propTypes.default.string,
  href: _propTypes.default.string,
  windowOptions: _propTypes.default.string,
  external: _propTypes.default.bool,
  rels: _propTypes.default.array,
  icon: _propTypes.default.string,
  dataCy: _propTypes.default.string,
  design: _propTypes.default.oneOf(['inline', 'icon', 'arrow']),
  inverted: _propTypes.default.bool,
  partial: _propTypes.default.string,
  _name: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  anchor: _propTypes.default.string,
  anchorOffset: _propTypes.default.number,
  ariaLabel: _propTypes.default.string,
  shrinkOn: _propTypes.default.oneOf(['mobile', 'tablet']),
  onClick: _propTypes.default.func,
  scriptAction: _propTypes.default.string,
  isPromo: _propTypes.default.bool,
  trackingCustomProperties: _propTypes.default.object,
  ..._button.default.propTypes
};